import { useRouter } from "@tanstack/react-router";
import { Client, SchemeFolioHolding } from "creso-core/types";
import { TransactionOrderType } from "creso-core/constants";
import { isActiveClient } from "creso-core/utils";
import {
  getHoldingFolioId,
  HoldingActionsDropdown,
  type HoldingActionConfig,
} from "web-core";

export function HoldingActions({
  holding,
  client,
}: {
  holding: SchemeFolioHolding;
  client?: Client;
}) {
  const router = useRouter();
  const folioId = getHoldingFolioId(holding);

  const openTransactionModal = (type: TransactionOrderType) => {
    router.navigate({
      to: ".",
      search: (prev) => ({
        ...prev,
        modal: "transaction",
        client_id: client?.id,
        isin: holding.scheme_isin,
        type,
        ...(folioId ? { folio_id: folioId } : {}),
      }),
    });
  };

  const openTransactionViewModal = () => {
    router.navigate({
      to: ".",
      search: (prev) => ({
        ...prev,
        modal: "transaction-list",
        isin: holding.scheme_isin,
        source: holding.internal_flag ? "INTERNAL" : "EXTERNAL",
        client_id: client?.id,
        ...(folioId ? { folio_id: folioId } : {}),
      }),
    });
  };

  const canTransact = isActiveClient(client) && holding.product_type !== "GIFT";

  const actions: HoldingActionConfig[] = [
    { label: "Transactions", onClick: openTransactionViewModal },
    {
      label: "Buy more",
      hidden: !(canTransact && holding.purchase_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.PURCHASE),
    },
    {
      label: "Redeem",
      hidden: !(canTransact && holding.redemption_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.REDEMPTION),
    },
    {
      label: "Start SIP",
      hidden: !(canTransact && holding.sip_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.XSIP),
    },
    {
      label: "Start STP",
      hidden: !(canTransact && holding.stp_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.STP),
    },
    {
      label: "Start SWP",
      hidden: !(canTransact && holding.swp_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.SWP),
    },
    {
      label: "Switch",
      hidden: !(canTransact && holding.switch_allowed),
      onClick: () => openTransactionModal(TransactionOrderType.SWITCH),
    },
  ];

  return <HoldingActionsDropdown actions={actions} />;
}
